import { createReducer } from 'redux-act';
import actions from '../actions/positionActions';

const initialState = {
    addPositionPending: false,
    addPositionRes: null,
    addPositionError: null,

    getAllPositionPending: false,
    getAllPositionRes: null,
    getAllPositionError: null,

    getPositionsByDepartmentDesignationPanding: false,
    getPositionsByDepartmentDesignationRes: null,
    getPositionsByDepartmentDesignationError: null,

    updatePositionPending: false,
    updatePositionRes: null,
    updatePositionError: null,

    deletePositionPending: false,
    deletePositionRes: null,
    deletePositionError: null,
};
/* Add Position Reducers */
const handleAddPositionRequest = state => {
    return {
        ...state,
        ...{
            addPositionPending: true,
            addPositionRes: null,
            addPositionError: null,
        },
    };
};
const handleAddPositionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addPositionPending: false,
            addPositionRes: payload,
            addPositionError: null,
        },
    };
};
const handleAddPositionError = (state, payload) => ({
    ...state,
    ...{
        addPositionPending: false,
        addPositionRes: null,
        addPositionError: payload,
    },
});


/* Get All Position Reducers */ 
const handleGetAllPositionRequest = state => {
    return {
        ...state,
        ...{
            getAllPositionPending: true,
            getAllPositionRes: null,
            getAllPositionError: null,
        },
    };
};
const handleGetAllPositionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllPositionPending: false,
            getAllPositionRes: payload,
            getAllPositionError: null,
        },
    };
};
const handleGetAllPositionError = (state, payload) => ({
    ...state,
    ...{
        getAllPositionPending: false,
        getAllPositionRes: null,
        getAllPositionError: payload,
    },
});

/*  Get Position By Department Designation Reducers */
const handleGetPositionsByDepartmentDesignationRequest = state => {
    return {
        ...state,
        ...{
            getPositionsByDepartmentDesignationPending: true,
            getPositionsByDepartmentDesignationRes: null,
            getPositionsByDepartmentDesignationError: null,
        },
    };
};
const handleGetPositionsByDepartmentDesignationSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getPositionsByDepartmentDesignationPending: false,
            getPositionsByDepartmentDesignationRes: payload,
            getPositionsByDepartmentDesignationError: null,
        },
    };
};
const handleGetPositionsByDepartmentDesignationError = (state, payload) => ({
    ...state,
    ...{
        getPositionsByDepartmentDesignationPending: false,
        getPositionsByDepartmentDesignationRes: null,
        getPositionsByDepartmentDesignationError: payload,
    },
});


/* Update Position Reducers */
const handleUpdatePositionRequest = state => {
    return {
        ...state,
        ...{
            updatePositionPending: true,
            updatePositionRes: null,
            updatePositionError: null,
        },
    };
};
const handleUpdatePositionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updatePositionPending: false,
            updatePositionRes: payload,
            updatePositionError: null,
        },
    };
};
const handleUpdatePositionError = (state, payload) => ({
    ...state,
    ...{
        updatePositionPending: false,
        updatePositionRes: null,
        updatePositionError: payload,
    },
});

/* Delete Position Reducers */
const handleDeletePositionRequest = state => {
    return {
        ...state,
        ...{
            deletePositionPending: true,
            deletePositionRes: null,
            deletePositionError: null,
        },
    };
};
const handleDeletePositionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            deletePositionPending: false,
            deletePositionRes: payload,
            deletePositionError: null,
        },
    };
};
const handleDeletePositionError = (state, payload) => ({
    ...state,
    ...{
        deletePositionPending: false,
        deletePositionRes: null,
        deletePositionError: payload,
    },
});

/* Clear Position Store */
const clearPositionStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_POSITION_STORE':
            return {
                ...state,
                ...{
                    addPositionPending: false,
                    addPositionRes: null,
                    addPositionError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_POSITION_STORE':
            return {
                ...state,
                ...{
                    updatePositionPending: false,
                    updatePositionRes: null,
                    updatePositionError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_POSITION_STORE':
            return {
                ...state,
                ...{
                    deletePositionPending: false,
                    deletePositionRes: null,
                    deletePositionError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addPositionRequest]: handleAddPositionRequest,
        [actions.addPositionSuccess]: handleAddPositionSuccess,
        [actions.addPositionError]: handleAddPositionError,

        [actions.getAllPositionRequest]: handleGetAllPositionRequest,
        [actions.getAllPositionSuccess]: handleGetAllPositionSuccess,
        [actions.getAllPositionError]: handleGetAllPositionError,

        [actions.getPositionsByDepartmentDesignationRequest]: handleGetPositionsByDepartmentDesignationRequest,
        [actions.getPositionsByDepartmentDesignationSuccess]: handleGetPositionsByDepartmentDesignationSuccess,
        [actions.getPositionsByDepartmentDesignationError]: handleGetPositionsByDepartmentDesignationError,

        [actions.updatePositionRequest]: handleUpdatePositionRequest,
        [actions.updatePositionSuccess]: handleUpdatePositionSuccess,
        [actions.updatePositionError]: handleUpdatePositionError,

        [actions.deletePositionRequest]: handleDeletePositionRequest,
        [actions.deletePositionSuccess]: handleDeletePositionSuccess,
        [actions.deletePositionError]: handleDeletePositionError,

        [actions.handleClearPositionStore]: clearPositionStore,
    },
    initialState,
);